import { render, staticRenderFns } from "./MyCourseRating.vue?vue&type=template&id=077df95e&scoped=true"
import script from "./MyCourseRating.vue?vue&type=script&lang=ts"
export * from "./MyCourseRating.vue?vue&type=script&lang=ts"
import style0 from "./MyCourseRating.vue?vue&type=style&index=0&id=077df95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077df95e",
  null
  
)

export default component.exports